import { boot } from 'quasar/wrappers'
import AxiosErrorHandler from "components/AxiosErrorHandler";
import { ApiAxiosInstance } from './ApiAxios'

console.log(ApiAxiosInstance.defaults)

const apiClient = {
    get(url) {
      return new Promise((resolve, reject) => {
        ApiAxiosInstance.get(url)
          .then(response => {
            if (response.data && response.data.success && response.data.success === true) {
              resolve(response)
            } else {
              AxiosErrorHandler.methods.showError(response)
              reject(response)
            }
          })
          .catch(err => {
            AxiosErrorHandler.methods.showError(err)
            reject(err)
          })
      })
    },
    post(url, data) {
      return new Promise((resolve, reject) => {
        ApiAxiosInstance.post(url, data)
          .then(response => {
            if (response.data &&
              ((response.data.success && response.data.success === true) || response.data.token)
            ) {
              resolve(response)
            } else {
              AxiosErrorHandler.methods.showError(response)
              reject(response)
            }
          })
          .catch(err => {
            AxiosErrorHandler.methods.showError(err)
            reject(err)
          })
      })
    },
    put(url, data, id) {
      return new Promise((resolve, reject) => {
        ApiAxiosInstance.put(url + id, data)
          .then(response => {
            if (response.data && response.data.success && response.data.success === true) {
              resolve(response)
            } else {
              AxiosErrorHandler.methods.showError(response)
              reject(response)
            }
          })
          .catch(err => {
            AxiosErrorHandler.methods.showError(err)
            reject(err)
          })
      })
    },
    silentget(url) {
        return new Promise((resolve, reject) => {
            ApiAxiosInstance.get(url)
                .then(response => {
                    if (response.data && response.data.success && response.data.success === true) {
                        resolve(response)
                    } else {
                        // AxiosErrorHandler.methods.showError(response)
                        reject(response)
                    }
                })
                .catch(err => {
                    // AxiosErrorHandler.methods.showError(err)
                    reject(err)
                })
        })
    },

}

export default apiClient

export { apiClient as ApiClientInstance }
